import React from 'react';
import { BsTwitter, BsInstagram, BsYoutube, BsLinkedin } from 'react-icons/bs';
import { FaFacebookF } from 'react-icons/fa';

const SocialMedia = () => {
  return (
    <div className="app__social">
        <div>
          <a href='https://www.youtube.com/rajeeshupendran' target="_blank" rel="noreferrer">
            <BsYoutube />
          </a>
        </div>
        <div>
          <a href='http://www.linkedin.com/in/rajeeshupendran' target='_blank' rel="noreferrer">
            <BsLinkedin />
          </a>
        </div>
        <div>
          <a href='http://twitter.com/rajeeshupendran' target='_blank' rel="noreferrer">
            <BsTwitter />
          </a>
        </div>
        <div>
          <a href='http://www.facebook.com/rajeesh.upendran' target='_blank' rel="noreferrer">
            <FaFacebookF />
          </a>
        </div>
        <div>
          <a href='https://www.instagram.com/rajeeshupendran/' target='_blank' rel="noreferrer">
            <BsInstagram />
          </a>
        </div>
    </div>
  )
}

export default SocialMedia